var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPediatrics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.5469C12.2616 10.5469 14.1016 8.70691 14.1016 6.44531C14.1016 4.18371 12.2616 2.34375 10 2.34375C7.7384 2.34375 5.89844 4.18371 5.89844 6.44531C5.89844 8.70691 7.7384 10.5469 10 10.5469ZM9.41406 8.78906C9.41406 8.46598 9.67691 8.20312 10 8.20312C10.3231 8.20312 10.5859 8.46598 10.5859 8.78906C10.5859 9.11215 10.3231 9.375 10 9.375C9.67691 9.375 9.41406 9.11215 9.41406 8.78906ZM10 3.51562C11.6154 3.51562 12.9297 4.82988 12.9297 6.44531C12.9297 7.40172 12.4689 8.25246 11.7578 8.7875C11.7569 7.81895 10.9688 7.03125 10 7.03125C9.03125 7.03125 8.24309 7.81895 8.24223 8.7875C7.53109 8.25246 7.07031 7.40172 7.07031 6.44531C7.07031 4.82988 8.38457 3.51562 10 3.51562Z",
    fill: "#6C5DD3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24219 4.6875H9.41406V5.85938H8.24219V4.6875Z",
    fill: "#6C5DD3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5859 4.6875H11.7578V5.85938H10.5859V4.6875Z",
    fill: "#6C5DD3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55469 6.44531V13.5547C3.55469 17.1086 6.44609 20 10 20C13.5539 20 16.4453 17.1086 16.4453 13.5547V6.44531C16.4453 2.89137 13.5539 0 10 0C6.44605 0 3.55469 2.89137 3.55469 6.44531ZM10 1.17188C12.9078 1.17188 15.2734 3.53754 15.2734 6.44531V13.5547C15.2734 16.4625 12.9078 18.8281 10 18.8281C7.09227 18.8281 4.72656 16.4625 4.72656 13.5547V6.44531C4.72656 3.53754 7.09223 1.17188 10 1.17188Z",
    fill: "#FF9A7B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5859 12.9688H9.41406V14.1406H8.24219V15.3125H9.41406V16.4844H10.5859V15.3125H11.7578V14.1406H10.5859V12.9688Z",
    fill: "#6C5DD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPediatrics);
export default __webpack_public_path__ + "static/media/pediatrics.96804bfa6303554b972249073e58056c.svg";
export { ForwardRef as ReactComponent };